import dayjs from "dayjs";
import { matchIsValidTel } from "mui-tel-input";

export const agentDefaultValues = {
  agentregno: "",
  agentname: "",
  agentemail: "",
  agentpassword: "",
  agentphone: "",
  agentdescription: "",
  agentcareerstarting: dayjs(new Date()),
  cityid: null,
  agentimage: "",
  nationality: null,
  nicimg: null,
  agentLanguages: [],

  // Supportive
  countryid: "",
  provid: "",

  // Documents
  idFile: null,
  passportFile: null,
  contractFile: null,
  idIssueDate: null,
  idExpiryDate: null,
  passportIssueDate: null,
  passportExpiryDate: null,
};


export const agentRules = {
  agentregno: { required: "Staff Registration No Required" },
  baseSalary: { required: "Basic Salary is Required" },
  agentname: { required: "Staff Name is Required" },
  agentemail: {
    required: "Staff Email is Required",
    pattern: {
      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
      message: "Invalid email address",
    },
  },
  agentpassword: { required: "Staff Password is Required" },
  agentphone: {
    validate: {
      phone: (value) => matchIsValidTel(value) || "Invalid phone number",
    },
  },
  agentdescription: {
    required: "Staff Description is Required",
    minLength: { value: 10, message: "At least 10 characters required" },
    maxLength: { value: 500, message: "Must not exceed 500 characters" },
  },
  agentcareerstarting: { required: "Career Starting Date Required" },
  cityid: { required: "City ID is Required" },
  agentimage: { required: "Staff Image is Required" },
  nationality: { required: "Nationality is Required" },
  role: { required: "Designation is Required" },
  agentLanguages: {
    validate: (v) => (v?.length > 0 ? true : "Select at least one language"),
  },
  countryid: { required: "Country must be selected" },
  provid: { required: "Province/State must be selected" },

  // === Document Validations ===
  idFile: { required: "ID document is required" },
  passportFile: { required: "Passport document is required" },
  contractFile: { required: "Contract file is required" },

  idIssueDate: { required: "ID issuance date is required" },
  idExpiryDate: {
    required: "ID expiry date is required",
    validate: (value, formValues) =>
      !value || !formValues.idIssueDate || value.isAfter(formValues.idIssueDate)
        ? true
        : "Expiry must be after issuance date",
  },

  passportIssueDate: { required: "Passport issuance date is required" },
  passportExpiryDate: {
    required: "Passport expiry date is required",
    validate: (value, formValues) =>
      !value ||
      !formValues.passportIssueDate ||
      value.isAfter(formValues.passportIssueDate)
        ? true
        : "Expiry must be after issuance date",
  },
};

